import { createAction } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';

export class HiddenMarketActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/hidden-market`;

    private static readonly SET_HAS_PLACED_FIRST_BET = `${HiddenMarketActions.ACTION_SCHEMA}/SET_HAS_PLACED_FIRST_BET`;

    /**
     * Sets that the first bet has been placed
     */
    static setHasPlacedFirstBet = createAction(HiddenMarketActions.SET_HAS_PLACED_FIRST_BET);
}
